import React, { Component } from "react"
import { ModalContainer, ModalDialog } from "react-modal-dialog"
import ReciboForm from "./ReciboForm"
import { HttpError } from "../../components"
export default class RecibosModal extends Component {
  constructor() {
    super()
    this.state = { isShowingModal: false }
  }
  render() {
    if (this.state.httpError) {
      return (
        <div onClick={this.props.onClose}>
          {this.props.show && (
            <ModalContainer onClose={this.props.onClose}>
              <ModalDialog
                style={{ width: "70%" }}
                onClose={this.props.onClose}
              >
                <HttpError
                  message={this.state.httpError.message}
                  status={this.state.httpError.status}
                />
              </ModalDialog>
            </ModalContainer>
          )}
        </div>
      )
    }
    return (
      <div onClick={this.props.onClose}>
        {this.props.show && (
          <ModalContainer onClose={this.props.onClose}>
            <ModalDialog style={{ width: "70%" }} onClose={this.props.onClose}>
              <ReciboForm callBack={this.props.callBack} />
            </ModalDialog>
          </ModalContainer>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/modais/RecibosModal.js